"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(2),
  boxSizing: 'border-box',
  display: 'grid',
  gap: theme.spacing(3),
  width: '100%',
  padding: theme.spacing(3),
  textAlign: 'center',
  a: {
    color: theme.palette.text.primary
  },
  '&:empty': {
    display: 'none'
  }
}));
//# sourceMappingURL=styles.js.map